__turbopack_context__.v({
  "container": "QMIDMW_container",
  "impact": "QMIDMW_impact",
  "smartdistributionlabel": "QMIDMW_smartdistributionlabel",
  "wrapper": "QMIDMW_wrapper",
});
